const TR_MAP: Record<string, string> = {
  ç: "c", ğ: "g", ı: "i", i: "i", ö: "o", ş: "s", ü: "u", â: "a", î: "i", û: "u",
};

/** Türkçe karakterleri ASCII'ye çevirip URL parçası üretir: "İspanya & Fas Turları" → "ispanya-fas-turlari" */
export function slugify(input: string): string {
  return input
    .toLocaleLowerCase("tr-TR")
    .replace(/[çğıiöşüâîû]/g, (ch) => TR_MAP[ch] ?? ch)
    .normalize("NFKD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

/** Türkçe duyarlı, aksan/büyük-küçük harf bağımsız arama anahtarı */
export function searchKey(input: string): string {
  return slugify(input).replace(/-/g, " ");
}

export function blankToNull(value: string | null | undefined): string | null {
  return value && value.trim() ? value : null;
}
